import {
  receiveOperation,
  getCustomerFileInfo,
  getCustomerHouseInfo,
  getCustomerPopulationInfo,
  getCustomerFitmentInfo,
  getCustomerOrderInfo,
  getOrderDesignDetail,
  getCustomerFollowInfo,
  shiftDesigner,
  getPreviewCategory,
  getPreviewList,
  getNewCustomerFollowInfo,
  getContractInfo,
  getCustomerInfo
} from '@/api/userProfile'

const state = {}

const mutations = {}

const actions = {

  // 02-接收/拒绝用户
  receiveOperation(temp, data) {
    return new Promise((resolve, reject) => {
      receiveOperation(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 03-查看档案
  getCustomerFileInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerFileInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 04-房屋信息
  getCustomerHouseInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerHouseInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 05-人口信息
  getCustomerPopulationInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerPopulationInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 06-装修需求
  getCustomerFitmentInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerFitmentInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 07-订单信息
  getCustomerOrderInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerOrderInfo(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 08-设计方案
  getOrderDesignDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderDesignDetail(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomerFollowInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getCustomerFollowInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  shiftDesigner({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      shiftDesigner(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPreviewCategory({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getPreviewCategory(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPreviewList({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getPreviewList(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewCustomerFollowInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getNewCustomerFollowInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getContractInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getContractInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomerInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getCustomerInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
